import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import React, { useState } from "react";
import axios from "axios";
import "./style.css";
import { Button } from "@delibrandev/utils";

// Inicializa Stripe con tu clave pública
const stripePromise = loadStripe(
  "pk_test_51QgrnzDEZOKlPhF3wGQXz3txJ3YHFBvcITGDx5PtjNaGcYjXEJTrTXIfvPZ3nhSIsvxe6kThhBhFW6ylZ11BsqhF00ODgYPJqz",
);

const CheckoutForm = ({ callback }) => {
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();
  const [paymentStatus, setPaymentStatus] = useState("");

  // Función auxiliar para mostrar errores
  const showError = (msg) => {
    setPaymentStatus(`Error: ${msg}`);
    console.log(msg);
  };

  // Maneja el envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Obtiene datos del pedido desde una función externa
      const data = await callback();
      if (!data) {
        showError("Datos de pago no disponibles");
        //navigate("/order-tracking/" + data.orderId);
        return;
      } else {
        console.log("Datos de pedido: ", data);
      }

      const cardElement = elements.getElement(CardElement);
      if (!cardElement) {
        showError("No se encontró el campo de tarjeta");
        //navigate("/order-tracking/" + data.orderId);
        return;
      }

      // Crea el método de pago con Stripe
      const { paymentMethod, error: paymentMethodError } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: {
          name: data.name,
          email: data.email,
        },
      });

      if (paymentMethodError) {
        showError("Error al crear el método de pago: " + paymentMethodError.message);
        data.cancelLoading();
        //navigate("/order-tracking/" + data.orderId);
        return;
      }

      const stripePaymentMethodId = paymentMethod.id;

      const total = data.amounts?.total;
      if (!Number.isFinite(total)) {showError("El importe del pedido necesita revisión antes del pago."); data.cancelLoading?.(); return;}

      // Envía los datos al backend para generar el clientSecret
      const res = await axios.post("pay-order", {
        orderId: data.orderId,
        paymentMethodId: data.paymentMethodId,
        stripePaymentMethodId,
        amount: total * 100, // Stripe espera el monto en centavos
        paymentMethods: {
          tarjeta: total,
        },
      });

      let clientSecret = false;
      if (res && !res.error) {
        clientSecret = res.data.data.clientSecret;
        console.log("clientSecret: ", clientSecret);

        if (!clientSecret) {
          showError("No se recibió clientSecret");
          //navigate("/order-tracking/" + data.orderId);
          return;
        }

        // Confirma el pago con el clientSecret recibido
        // TODO - ver porque siempre da error esto pero realmente el pago si se realiza
        const result = await stripe.confirmCardPayment(clientSecret);
        console.log("result confirmCardPayment =======> ", result);

        if (result && result.paymentIntent && result.paymentIntent.status && result.paymentIntent.status === "succeeded") {
          setPaymentStatus("Pago exitoso");
          data.functionCallback(data.data, "paid");
          //navigate("/order-tracking/" + data.orderId);
          //navigate(data.urlCallback);
        } else if (
          result &&
          result.paymentIntent &&
          result.paymentIntent.status &&
          result.paymentIntent.status === "requires_action"
        ) {
          setPaymentStatus("Pago requiere autenticación adicional");
          //navigate("/order-tracking/" + data.orderId);
        } else if (!result || !result.paymentIntent) {
          showError("Error al confirmar el pago");
          return;
        } else {
          showError("Estado inesperado del pago: ");
          //navigate("/order-tracking/" + data.orderId);
        }
      } else {
        showError("Estado inesperado del pago.");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Error desconocido";
      showError("Pago fallido: " + errorMessage);
      console.error("Error procesando el pago:", error);
      //navigate("/checkout");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="checkout-form">
      <div className="card-element-container">
        <CardElement className="card-element" options={{ hidePostalCode: true }} />
      </div>
      <div className="mobileRender">
        <div className="flex-gap">
          <div className="" style={{ flex: "1" }}>
            <Button text={"Volver"} icon={null} customClass={"customButtonColor1 w100"} action={() => navigate("/carrito")} />
          </div>
          <div style={{ flex: "0 0 70%" }}>
            <button type="submit" disabled={!stripe || !elements} className="pay-button bigMobileButton w100">
              Pagar
            </button>
          </div>
        </div>
      </div>
      <div className="desktopRender w-100">
        <div style={{ flex: "0 0 100%" }}>
          <button type="submit" disabled={!stripe || !elements} className="pay-button bigMobileButton w100">
            Pagar
          </button>
        </div>
      </div>

      {paymentStatus !== "" && <p className="payment-status">{paymentStatus}</p>}
    </form>
  );
};

// Componente principal que envuelve el formulario con el contexto de Stripe
export const Stripe = ({ callback }) => (
  <Elements stripe={stripePromise}>
    <CheckoutForm callback={callback} />
  </Elements>
);
